var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65137 6.31032L3.29781 5.95775L2.94475 6.31082L1.95775 7.29782L1.6042 7.65137L1.95775 8.00492L5.45775 11.5049L5.81131 11.8585L6.16486 11.5049L12.4649 5.20492L12.8172 4.85262L12.4661 4.49907L11.4791 3.50507L11.1256 3.14901L10.7708 3.50382L5.81081 8.46375L3.65137 6.31032ZM7.21075 14.1514C5.92537 14.1513 4.66887 13.77 3.6001 13.0559C2.53118 12.3417 1.69806 11.3265 1.20609 10.1388C0.71412 8.95109 0.585399 7.64416 0.836203 6.38328C1.08701 5.12241 1.70607 3.96422 2.61511 3.05518C3.52415 2.14613 4.68234 1.52707 5.94322 1.27627C7.20409 1.02546 8.51103 1.15418 9.69875 1.64615C10.8865 2.13812 11.9016 2.97124 12.6159 4.04016C13.33 5.10893 13.7112 6.36543 13.7113 7.65081C13.7094 9.37428 13.0239 11.0266 11.8052 12.2453C10.5865 13.464 8.93422 14.1495 7.21075 14.1514Z",
    fill: "#126399",
    stroke: "#126399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckBlue);
export default __webpack_public_path__ + "static/media/iconCheckBlue.68389068e0e139fe40d424f8487f2b6c.svg";
export { ForwardRef as ReactComponent };